import { createSlice, createAction } from "@reduxjs/toolkit";
import { ConvertTagsToHtml, ConvertHtmlToTags, TagToHtml } from "../helpers/TagHelper";

//generators
export const injectTagAction = createAction("segments/injectTagAction");
export const generateCopySourceAction = createAction("segments/generateCopySourceAction");
export const generateAcceptSegmentAction = createAction("segments/generateAcceptSegmentAction");

//State
export const Tag = {
  Type: "bpt" | "ept" | "ph" | "not-found",
  Value: "",
  Start: 0,
  End: 0,
};
export const DisplayedSegment = {
  Locked: false,
  SourceId: 0,
  TargetId: 0,
  Source: "",
  Target: "",
  SourceTextHtml: "",
  SourcePlainText: "",
  TargetPlainText: "",
  TargetTextHtml: "",
  SourceTags: [{ Tag }],
  Draft: "",
};

//Reducer
const slice = createSlice({
  name: "segments",
  initialState: {
    segments: [],
    isLoading: true,
    error: false,
  },
  reducers: {
    segmentsIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    addDisplayedSegments: (state, action) => {
      let segments = action.payload;

      //const strings = props.file.uploadedFile.transUnits.map((x) => x.segmentText);
      const segm = [];
      for (let x in segments.segments) {
        const source = ConvertTagsToHtml(segments.segments[x].sourceText);

        const target = ConvertTagsToHtml(segments.segments[x].targetText);

        let obj = {};

        obj.SourceId = segments.segments[x].segmentId;
        obj.TargetId = segments.segments[x].segmentId;
        obj.Source = segments.segments[x].sourceText;
        obj.Target = segments.segments[x].targetText;
        obj.SourceTextHtml = source.ResultHTML;
        obj.TargetTextHtml = target.ResultHTML;
        obj.SourcePlainText = source.PlainText;
        obj.TargetPlainText = target.PlainText;
        obj.SourceTags = target.Tags;
        obj.isOpened = false;

        segm.push(obj);
      }

      state.segments = segm;
      //state.isLoading = false;
    },
    acceptTranslatedSegment: (state, action) => {
      let convertTag = TagToHtml(action.payload.text);
      state.segments.find((x) => x.TargetId === action.payload.id).TargetTextHtml = action.payload.text;
      state.segments.find((x) => x.TargetId === action.payload.id).Target = convertTag.ResultHTML;
      state.segments.find((x) => x.TargetId === action.payload.id).isAccepted = true;
    },
    segmentIsOpened: (state, action) => {
      let openedSegments = state.segments.filter((x) => x.isOpened === true);
      if (openedSegments.length > 0) {
        state.segments.forEach((x) => {
          if (x.TargetId !== action.payload) x.isOpened = false;
        });
        state.segments.find((x) => x.TargetId === action.payload).isOpened = true;
      } else {
        state.segments.find((x) => x.TargetId === action.payload).isOpened = true;
      }
    },
    copyFromSourceSegment: (state, action) => {
      state.segments.find((x) => x.TargetId === action.payload.id).TargetTextHtml = action.payload.text;
    },
    updateSegment: (state, action) => {
      state.segments.find((x) => x.TargetId === action.payload.id).TargetTextHtml = action.payload.text;
    },
  },
});

export const { segmentsIsLoading, addDisplayedSegments, acceptTranslatedSegment, segmentIsOpened, copyFromSourceSegment, updateSegment } = slice.actions;

export default slice.reducer;
